import React, { useState, useEffect, Component } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExportBLAttachedDT = (props) => {
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Aditional Details </Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder=""
                    name="AditionalDetails"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.AditionalDetails
                        ? props.pageValuesData.AditionalDetails
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ExportBLAttachedDT;
